export const SlaInfoTableColumnIdsEnum = {
  ORDER_NUMBER: 'orderNumber',
  DURATION_HOURS: 'durationHours',
  POTENTIAL_ASSIGNEES: 'potentialAssignees',
  ASSIGNED_USERS: 'assignedUsers',
  ASSIGNMENT_TYPE: 'assignmentType',
  START_DATE: 'startDate',
  TYPE: 'type',
};

export const columns = [
  {
    id: SlaInfoTableColumnIdsEnum.ASSIGNMENT_TYPE,
    align: 'left',
    label: 'SLA LEVEL',
    className: 'w-1/6',
  },
  {
    id: SlaInfoTableColumnIdsEnum.DURATION_HOURS,
    align: 'left',
    label: 'SLA',
    className: 'w-1/12',
  },
  {
    id: SlaInfoTableColumnIdsEnum.POTENTIAL_ASSIGNEES,
    align: 'left',
    label: 'POTENTIAL USERS',
  },
  {
    id: SlaInfoTableColumnIdsEnum.ASSIGNED_USERS,
    align: 'left',
    label: 'USERS TO COMPLETE',
    className: 'w-1/6',
  },
  {
    id: SlaInfoTableColumnIdsEnum.TYPE,
    align: 'left',
    label: 'ASSIGNMENT TYPE',
    className: 'w-1/6',
  },
  {
    id: SlaInfoTableColumnIdsEnum.START_DATE,
    align: 'left',
    label: 'SLA START DATE/TIME',
    className: 'w-1/6',
  },
];
